(function () {

  function initCollectionSubscriptions() {

    const cards = document.querySelectorAll(
      '.collection-subscription'
    );

    if (!cards.length) {
      return;
    }

    cards.forEach(function (card) {

      // Prevent initializing the same card twice
      if (card.dataset.subscriptionInitialized === 'true') {
        return;
      }

      card.dataset.subscriptionInitialized = 'true';


      const options = card.querySelectorAll(
        '.collection-subscription__option'
      );

      const radios = card.querySelectorAll(
        '.collection-subscription__radio'
      );

      const select = card.querySelector(
        '[data-subscription-select]'
      );

      const orderButton = card.querySelector(
        '[data-subscription-add]'
      );


      /*
       * Purchase option selection
       */

      radios.forEach(function (radio) {

        radio.addEventListener('change', function () {

          options.forEach(function (option) {
            option.classList.remove('is-active');
          });

          const currentOption = radio.closest(
            '.collection-subscription__option'
          );

          if (currentOption) {
            currentOption.classList.add('is-active');
          }


          if (select) {

            select.disabled =
              radio.value !== 'subscription';

          }

        });

      });


      /*
       * Add to cart
       */

      if (orderButton) {

        orderButton.addEventListener(
          'click',
          async function () {

            const selectedRadio = card.querySelector(
              '.collection-subscription__radio:checked'
            );

            if (!selectedRadio) {
              return;
            }


            const variantId = card.dataset.variantId;

            if (!variantId) {

              console.error(
                'Subscription: Variant ID missing.'
              );

              return;

            }


            let sellingPlanId = null;


            if (
              selectedRadio.value === 'subscription' &&
              select
            ) {

              sellingPlanId = select.value;

            }


            orderButton.disabled = true;


            const item = {
              id: Number(variantId),
              quantity: 1
            };


            if (sellingPlanId) {

              item.selling_plan =
                Number(sellingPlanId);

            }


            try {

              const response = await fetch(
                window.Shopify.routes.root +
                'cart/add.js',
                {
                  method: 'POST',

                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },

                  body: JSON.stringify({
                    items: [item]
                  })
                }
              );


              const result =
                await response.json();


              if (!response.ok) {

                throw new Error(
                  result.description ||
                  'Unable to add product to cart.'
                );

              }


              console.log(
                'Product added:',
                result
              );


              /*
               * Notify Shopify theme
               */

              document.dispatchEvent(
                new CustomEvent('cart:refresh')
              );


              /*
               * Try common cart drawer implementations
               */

              const cartDrawer =
                document.querySelector('cart-drawer');


              if (
                cartDrawer &&
                typeof cartDrawer.open === 'function'
              ) {

                cartDrawer.open();

              } else {

                window.location.href =
                  window.Shopify.routes.root +
                  'cart';

              }


            } catch (error) {

              console.error(
                'Subscription cart error:',
                error
              );

              alert(
                error.message ||
                'Something went wrong.'
              );

            } finally {

              orderButton.disabled = false;

            }

          }
        );

      }

    });

  }


  /*
   * Initial page load
   */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initCollectionSubscriptions
    );

  } else {

    initCollectionSubscriptions();

  }


  /*
   * Shopify/theme sections can be
   * re-rendered dynamically.
   */

  document.addEventListener(
    'shopify:section:load',
    initCollectionSubscriptions
  );


  /*
   * Watch for product cards added dynamically.
   */

  const observer = new MutationObserver(
    function () {
      initCollectionSubscriptions();
    }
  );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();